export { default } from "./DashboardQuery";
